import React, { useEffect } from 'react';

import { Grid, Box, Typography } from '@mui/material';
import CustomTextField from '../../../../components/CustomTextField/CustomTextField';

const socialMediaFields = [
  { label: 'Instagram', url: 'https://instagram.com/' },
  { label: 'LinkedIn', url: 'https://linkedin.com/in/' },
  { label: 'Twitter', url: 'https://twitter.com/' },
  { label: 'Facebook', url: 'https://facebook.com/' },
  { label: 'Other', url: 'https://' },
];

const ManageSocialAccountsFields = ({
  socialsData,
  setSocialsData,
  setShowIcons,
}: any) => {
  useEffect(() => {
    // Check if any of the social media fields are filled
    const anySocialFilled = socialMediaFields.some(
      (field) => !!socialsData[field.label.toLowerCase()]
    );

    // Update the showIcons.manageSocialAccounts state
    setShowIcons((prevState: any) => ({
      ...prevState,
      manageSocialAccounts: anySocialFilled,
    }));
  }, [socialsData, setShowIcons]);

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { name, value } = e.target;
  //   setSocialsData((prevData: any) => {
  //     const updatedData = {
  //       ...prevData,
  //       [name]: value,
  //     };

  //     // Update the socialMediaLinks array
  //     const socialMediaLinks = socialMediaFields.map((field) => ({
  //       url: updatedData[field.label.toLowerCase().replace(' ', '-')],
  //     }));

  //     return {
  //       ...updatedData,
  //       socialMediaLinks,
  //     };
  //   });
  // };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    // Update only the individual field values in socialsData
    setSocialsData((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };

  return (
    <Grid
      spacing={3}
      p={{ xs: 2, md: 5 }}
      mt={{ xs: 3, md: 0 }}
      display={'flex'}
      flexDirection={'column'}
      gap={3}>
      {socialMediaFields.map((field, index) => {
        const fieldName = field.label.toLowerCase().replace(' ', '-'); // Convert label to form field name
        return (
          <Grid key={index} item xs={12}>
            <Typography
              variant='body1'
              sx={{
                fontWeight: 400,
                fontSize: '17px',
                color: '#000000',
                marginBottom: 1,
              }}>
              {field.label}
            </Typography>
            <Box display='flex' alignItems='center'>
              <Typography
                sx={{
                  color: '#666',
                  marginRight: 1,
                  whiteSpace: 'nowrap',
                  width: '180px',
                }}>
                {field.url}
              </Typography>
              <Box sx={{ flexGrow: 1 }}>
                <CustomTextField
                  name={fieldName}
                  sx={{ width: '100%', maxWidth: '458px', height: '50px' }}
                  value={socialsData[fieldName] || ''}
                  onChange={handleChange}
                />
              </Box>
            </Box>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ManageSocialAccountsFields;
